<template>
  <v-dialog v-model="dialog" width="unset">
    <v-card>
      <v-card-title class="headline">Úkony výrobného príkazu: {{manufacturingCommandDetail.id}}</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="tableHeaderDetail"
          :items="manufacturingCommandDetail.workplaceSchedules"
          :items-per-page="10"
          class="transparent"
          dense
        >
          <template v-slot:item.state="{ item }">
            <Tooltip :data="getWorkplaceTrackStatus(item)" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" text @click="dialog = false">Zatvor</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Tooltip from "@/views/manufacturing_command/components/Tooltip";
import { tableHeaderDetail } from "@/views/manufacturing_command/js/tableHeaders";
import { getWorkplaceTrackStatus } from "@/views/manufacturing_command/js/manufacturingCommand";

export default {
  name: "ManufacturingCommandWorkplaceState",
  components: {
    Tooltip
  },
  data: () => ({
    dialog: false,
    manufacturingCommandDetail: {},
    tableHeaderDetail: tableHeaderDetail,
    getWorkplaceTrackStatus: getWorkplaceTrackStatus
  }),

  methods: {
    detailClick(commandId) {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .manufacturingCommandService()
        .getManufacturingCommandInProduction(commandId)
        .then(response => {
          this.manufacturingCommandDetail = response.data;
          this.dialog = true;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    openDialog(commandId) {
      this.detailClick(commandId);
    }
  }
};
</script>
